import React, { Component } from 'react';
import SelectOrganizationAutocomplete from './SelectOrganizationAutocomplete';
import OrganizationSelectList from './OrganizationSelectList';
import { translate } from '../Services/translation';

class SelectOrganization extends Component {
    focusOnInput() {
        setTimeout(() => {
            this.searchInput && this.searchInput.focus();
        }, 0);
    }
    render() {
        const { query, result, organizationList, defaultNumber, defaultName, showResult, showFullForm, onSearch, onBlur, onKeyDown, toggleShowFullForm, selectedItem, onSelectOrg, selectOnChange, onOrgSubmit, selectedOrg } = this.props;
        return (
            <div className="select-org" role="search" >
                <a className="select-org__link--block" onClick={e => { toggleShowFullForm(); this.focusOnInput() }}>
                    <i className="select-org__icon--mobile"></i>
                    <span className="select-org__org-name">{defaultName} ({defaultNumber})</span>
                    <span className="select-org__icon">&#x25BC;</span>
                    <span className="select-org__title">{translate('general.search.organization')}</span>
                </a>
                <div className={`select-org__form ${showFullForm ? 'select-org__form--force-show' : ''}`} role="search">
                    <div className="row">
                        <div className="small-12 columns">
                            <div className="select-org__input-wrap">

                                <input className="select-org__input" type="search" placeholder={translate('general.search.organization')}
                                    autoComplete="off" value={query} onChange={event => onSearch(event.target.value)}
                                    onKeyDown={event => onKeyDown(event)}
                                    ref={(input) => { this.searchInput = input; }}
                                    onBlur={() => onBlur()} />
                        
                                    {showResult && <SelectOrganizationAutocomplete result={result} selectedItem={selectedItem} onSelectOrg={onSelectOrg} />}
                                
                                <OrganizationSelectList organizationList={organizationList} onOrgSubmit={onOrgSubmit} translate={translate} selectedOrg={selectedOrg} selectOnChange={selectOnChange} />
                            </div>
                        </div>
                    </div>
                   
                </div>

            </div>
        )
    }
}

export default SelectOrganization;

